// AnniversaryPhotoGallery — placeholder section for the 「封面照片」 future
// feature (W3.1 §5.2 + §6.3). W3.1 ships a static placeholder + W3.2 copy.

import { Camera } from "lucide-react";

export function AnniversaryPhotoGallery() {
  return (
    <section
      data-component="AnniversaryPhotoGallery"
      className="rounded-md bg-paper-tint1 border border-dashed border-hairline-strong p-5 flex flex-col items-center gap-2 text-center"
      data-testid="anniversary-photo-gallery"
    >
      <span
        aria-hidden
        className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-paper-deep text-ink-2"
      >
        <Camera size={20} strokeWidth={1.5} />
      </span>
      <p className="text-body-sm text-ink-2">封面照片</p>
      <p className="text-meta text-ink-3">
        從相簿挑選照片關聯到此紀念日 (預計 W3.2 加入)
      </p>
    </section>
  );
}